import { TFunction } from "i18next";
import React from "react";

import Countdown from "~/components/days-till/Countdown";
import { DateDiff } from "~/helpers/dates.server";

interface Props {
  isItNow: boolean,
  diff: DateDiff,
  endDiff: DateDiff|null,
  nextStartDate: Date,
  t: TFunction,
  tkey: string,
  hydrated?: boolean,
}

const FullCountdown: React.FC<Props> = (
  {
    isItNow,
    diff,
    endDiff,
    nextStartDate,
    t,
    tkey,
    hydrated = true,
  }
) => {
  return (
    <>
      {isItNow && endDiff ? <>
        <div className="w-full text-slate-900 dark:text-white font-bold text-[1.4rem] md:text-[1.8rem] text-center">
          <div className="my-10 font-extrabold text-[3rem] md:text-[4rem] lg:text-[5rem]">
            {t(`${tkey}.it_is_now`)}
          </div>
          <div>{t(`${tkey}.it_will_end_in`)}</div>
          <div className="font-extrabold text-[3rem] md:text-[4.5rem]">
            {endDiff.totalDays} {t(`${tkey}.days`, { count: endDiff.totalDays })}
          </div>
          <p className="pt-10 md:pt-16">{t(`${tkey}.left_till_next`, { year: nextStartDate.getFullYear() })}</p>
        </div>
        <div
          className="w-full flex flex-row gap-10 justify-center text-center items-baseline mb-10 md:mb-6 font-extrabold uppercase text-slate-900 dark:text-white"
        >
          <span className="text-[7rem] md:text-[11rem]">
            {diff.totalDays}
          </span>
          <span
            className="text-[3rem] md:text-[5rem] md:text-left uppercase">
            {t(`${tkey}.days`, { count: diff.totalDays })}
          </span>
        </div>
      </> : (
        <div
          className="w-full flex flex-col md:flex-row md:gap-10 justify-center items-center mb-10 md:mb-0 font-extrabold uppercase text-slate-900 dark:text-white">
          <div className="text-[7rem] md:text-[11rem]">
            {diff.totalDays}
          </div>
          <div
            className="flex flex-col pt-2 text-[3rem] md:text-[3rem] justify-center md:justify-start text-center md:text-left uppercase">
            <div>{t(`${tkey}.days`, { count: diff.totalDays })}</div>
            <div>{t(`${tkey}.till_event`)}</div>
          </div>
        </div>
      )}

      <Countdown
        diff={diff}
        t={t}
        tkey={tkey}
        hydrated={hydrated}
      />
    </>
  );
};

export default FullCountdown;